import React from 'react';

function Home() {
  return( 
    <div className="welcome">
      <h1>
        <div>Hello, World!</div>
      </h1>
    </div>
  );
}

export default Home



// WEBPACK FOOTER //
// ./src/views/Home.js